import { useIsLoggedInQuery } from 'auth/hooks'
import { SkeletonItem } from 'components/skeleton-item'
import * as React from 'react'
import { tw } from 'utils/classnames'
import { FeedLink } from '../feed-link'

import { ProfileInfoCard, SkeletonProfileHeader } from './profile-info-card'
import { LogoutUserSection, LogoutUserSectionSkeleton } from './logout-user-section'

export function UserProfilePanel({
  slug,
  isSubDetailSection,
  isShowFollowersCount,
}: {
  slug?: string
  isSubDetailSection?: boolean
  isShowFollowersCount?: boolean
}) {
  // eslint-disable-next-line cf-web/codegen-query-patterns
  const isUserLoggedIn = useIsLoggedInQuery()

  return (
    <div>
      {isUserLoggedIn.isPending ? (
        isSubDetailSection ? (
          <SkeletonProfileHeader />
        ) : (
          <LogoutUserSectionSkeleton />
        )
      ) : isUserLoggedIn.data || isSubDetailSection ? (
        <ProfileInfoCard
          slug={slug}
          isSubDetailSection={isSubDetailSection}
          isShowFollowersCount={isShowFollowersCount}
        />
      ) : (
        <LogoutUserSection />
      )}
    </div>
  )
}

export function LoadingProfile() {
  return (
    <div className="flex flex-col items-center rounded-[12px] bg-white px-4 pb-6 pt-[34px]">
      <SkeletonItem className="h-[56px] w-[56px] rounded-full" />
      <SkeletonItem className="mt-4" />
      <>
        <SkeletonItem className="mt-1" />
        <SkeletonItem className="mt-5 h-[30px]" />
        <SkeletonItem className="mt-10" />
        <SkeletonItem className="mt-5" />
        <SkeletonItem className="mt-5" />
        <SkeletonItem className="mt-5" />
        <SkeletonItem className="mt-5" />
      </>
    </div>
  )
}

export function LinkItem({
  href,
  children,
  onClick,
  className,
}: React.PropsWithChildren<{
  href: string
  onClick?: React.MouseEventHandler
  className?: string
}>) {
  return (
    <FeedLink
      href={href}
      className={tw('text-cf-dreamy-cloud-900 flex flex-row items-center gap-3 p-2', className)}
      onClick={onClick}
    >
      {children}
    </FeedLink>
  )
}
